import React from 'react';

import { Text } from '@change/ds-core-ui/Text';

// TODO: move headline and subheading text to the translation file when productized
export const Headline: React.FC<EmptyProps> = () => {
	return (
		<div className="flex flex-col gap-2">
			<Text
				as="h3"
				variant="heading"
				size="small"
				className="m-0"
				data-qa="promote-heading"
				data-testid="promote-heading"
			>
				How much would you like to chip in?
			</Text>
			<Text className="text-typography-strong md:text-lg" data-qa="promote-subheading" data-testid="promote-subheading">
				Every dollar goes towards increasing visibility of this petition.
			</Text>
		</div>
	);
};
